// TODO
// - Add validation checks

import { get } from "lodash";
import moment from "moment-timezone";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container, Header } from "semantic-ui-react";
import { Formik, Form } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import ScheduleCorePanel from "./ScheduleCorePanel.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";
import ScheduleActionsPanel from "./scheduleActionsPanel/ScheduleActionsPanel.jsx";
import ResourcePicker from "../forms/resourcePicker/ResourcePicker.jsx";

import { MODES } from "../forms/formConstants.js";

import {
  combinePlannerArrays,
  splitResourceArray
} from "../../state/reducers/schedules/scheduleUtils.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ScheduleForm extends Component {
  static propTypes = {
    schedule: PropTypes.object,
    mode: PropTypes.string.isRequired,
    showValidation: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    showValidation: false,
    mode: MODES.CREATE
  };

  constructor(props) {
    super(props);

    this.state = {
      initialValues: ScheduleForm.createDraftFromProps(props),
      schedule: props.schedule
    };

    // set moment language locale - not really in use yet
    moment.locale(props.locale);
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props.schedule !== state.schedule) {
      return {
        initialValues: ScheduleForm.createDraftFromProps(props),
        schedule: props.schedule
      };
    }

    return null;
  };

  // -- HELPERS -- //

  static createDraftFromProps = props => {
    const { schedule, defaultTimezone } = props;

    // must have base initial values for setTouched to work
    if (!schedule) {
      return {
        name: "",
        description: "",
        timezone: defaultTimezone,
        startAt: null,
        endAt: null,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        resources: []
      };
    }

    return {
      ...schedule,
      name: get(schedule, "name", "") || "",
      description: get(schedule, "description", "") || "",
      timezone: get(schedule, "timezone", null) || defaultTimezone,
      resources: combinePlannerArrays(schedule)
    };
  };

  // -- VALIDATION -- //

  validationScheme = () => {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      actions: ScheduleActionsPanel.validationScheme(messages),

      name: Schemas.simpleStringSchema("Name", messages, true),
      description: Yup.string(),
      timezone: Schemas.timezoneSchema("Timezone", messages, true),

      startAt: Schemas.dropdownSchema("Start on", messages, true),
      endAt: Schemas.dropdownSchema("End at", messages, false),

      monday: Schemas.requiredBoolean("Monday", messages),
      tuesday: Schemas.requiredBoolean("Tuesday", messages),
      wednesday: Schemas.requiredBoolean("Wednesday", messages),
      thursday: Schemas.requiredBoolean("Thursday", messages),
      friday: Schemas.requiredBoolean("Friday", messages),
      saturday: Schemas.requiredBoolean("Saturday", messages),
      sunday: Schemas.requiredBoolean("Sunday", messages)

      // none of the below are currently required
      // workstations: Yup.array().of(Schemas.requiredString("Workstations", messages)),
      // containers: Yup.array().of(Schemas.requiredString("Containers", messages)),
      // databases: Yup.array().of(Schemas.requiredString("Databases", messages)),
      // nodes: Yup.array().of(Schemas.requiredString("Nodes", messages))
    });
  };

  // -- HANDLERS -- //

  onFormikSubmit = values => {
    const { schedule } = this.props;

    let parsedValues = { ...values };

    // format resource data
    if (values.resources) {
      parsedValues = {
        ...values,
        ...splitResourceArray(schedule, values.resources)
      };
    }

    // delete parsedValues.resources;

    // format timezone
    if (values.timezone) {
      parsedValues.timezone = values.timezone["@id"];
    }

    this.props.onSubmit(parsedValues);
  };

  // -- RENDER -- //

  getTitle = () => {
    const { mode, schedule, copy } = this.props;

    if (mode !== MODES.CREATE) {
      return `${copy("schedule.title")}: ${schedule.name}`;
    }

    return copy("schedule.new_title");
  };

  getActionPanelCopy = type => {
    const { mode, copy } = this.props;
    const copyKey = mode !== MODES.CREATE ? "edit" : "create";
    return copy(`schedule.${type}.${copyKey}`);
  };

  render() {
    const { mode, onCancel, onReset, violationErrors, copy } = this.props;

    const readOnly = mode === MODES.READ;
    const disabled = readOnly;

    return (
      <Formik
        initialValues={this.state.initialValues} // required by semantic-ui react
        validateOnMount={true}
        enableReinitialize={true}
        validationSchema={this.validationScheme()}
        onSubmit={this.onFormikSubmit}
      >
        {formikProps => {
          return (
            <Container className="main-responsive">
              <Header as="h3" className="clear-both">
                {this.getTitle()}
              </Header>

              <Form className="ui form clear-both">
                {/* {get(formikProps.values, "requestAction.type", null) ===
                  SCHEDULES.POST && (
                  <SegmentMessage
                    title={copy(`schedule.messages.created.title`)}
                    message={copy(`schedule.messages.created.message`)}
                    dismissable={true}
                    positive={true}
                  />
                )} */}

                <ScheduleCorePanel
                  id={"core"}
                  readOnly={readOnly}
                  disabled={disabled}
                  formikProps={formikProps}
                  violationErrors={violationErrors}
                />

                <ScheduleActionsPanel
                  id={"actions"}
                  readOnly={readOnly}
                  disabled={disabled}
                  formikProps={formikProps}
                  violationErrors={violationErrors}
                />

                <ResourcePicker
                  id={"resources"}
                  readOnly={readOnly}
                  disabled={disabled}
                  formikProps={formikProps}
                  violationErrors={violationErrors}
                  showValidation={false}
                  onChange={this.onResourcesChange}
                />

                {mode !== MODES.READ && (
                  <FormikActionsPanel
                    onCancel={onCancel}
                    reset={true}
                    onReset={onReset}
                    submit={true}
                    useSubmitModal={false}
                    modalCopy={this.getActionPanelCopy("modals")}
                    panelCopy={this.getActionPanelCopy("actions_panel")}
                  />
                )}
              </Form>
            </Container>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = state => ({
  defaultTimezone: get(state, "account.timezone", { "@id": undefined }), // should be refactored into selector
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ScheduleForm);
